import React, { useCallback, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useInfiniteQuery } from "@tanstack/react-query";
import ArticleCard from "../../../common/ArticleCard";
import Loading from "../../../common/Loading";
import { getUserSearchedContent } from "../../../../store/api/content";

const SearchedContent = ({
  searchParams, // { search, region, topic, type }
  isMobile,
  isTablet,
}) => {
  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: [
      "searchedContentPaginated",
      searchParams.search,
      searchParams.region,
      searchParams.topic,
      searchParams.type,
    ],
    queryFn: ({ pageParam = "" }) =>
      getUserSearchedContent({
        searchTerm: searchParams.search,
        usersIds: null,
        topicIds: searchParams.topic.length ? searchParams.topic : null,
        regionIds: searchParams.region.length ? searchParams.region : null,
        typeIds: searchParams.type.length ? searchParams.type : null,
        continuationToken: pageParam, // Add continuation token for pagination
      }),
    getNextPageParam: (lastPage) => lastPage.continuationToken || null,
    enabled: !!(
      searchParams.region.length > 0 ||
      searchParams.topic.length > 0 ||
      searchParams.type.length > 0 ||
      searchParams.search.length > 2
    ),
  });

  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.scrollHeight - 20
    ) {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  if (isLoading) return <Loading />;
  if (error)
    return (
      <Typography variant="body1">Error loading search results</Typography>
    );

  // Get all articles from all pages
  const allArticles =
    data?.pages.flatMap((page) => page.paginatedContent) || [];

  return (
    <section className="sectionCenter">
      <Box sx={{ padding: 2 }}>
        <Grid container spacing={isMobile ? 1 : 2}>
          {allArticles.map((article) => (
            <ArticleCard
              key={article.id}
              article={article}
              isMobile={isMobile}
              isTablet={isTablet}
            />
          ))}
        </Grid>
        {isFetchingNextPage && <Loading />}
      </Box>
    </section>
  );
};

export default SearchedContent;
